import { render } from "./BotonEgresoEmbargoPersonaComponent.vue?vue&type=template&id=b4a2767a"
import script from "./BotonEgresoEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonEgresoEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__